import { gql } from "@apollo/client";


export const EXISTE_AUTORIZACION = gql`
    query existeAutorizacion ($idEvaluacion: Int!) {
        existeAutorizacion
        (
            idEvaluacion: $idEvaluacion,
        ) 
        {
            success,
            error,
            valorEsperado
        }
}`;